import React from "react";
import { interests } from "./interests.jsx";
import "./areaOfInterest.css";

const AreaOfInterestPage = () => {
  return (
    <>
      <div>
        <div className="title">
          <h1 className="title-part-1">Areas of</h1>
          <h1 className="title-part-2">Interest</h1>
        </div>
        <div>
          {interests.map((interest, index) => (
            <div key={index} className="interest-item">
              <div className="boxes">
                <div className="box-1 "></div>
                <div className="box-2 ">
                  <div className="interest-title-box">
                    <h1 className="interest-title">{interest.title}</h1>
                  </div>
                </div>
              </div>
              <p className="content-box">{interest.content} </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AreaOfInterestPage;
